export const V1_ROUTES = {
  PROFILE: 'dashboard/clients/assessment',
  NEW_SALE: 'payments/payments/addnew',
  PAYMENTS: 'payments/payments',
}

export const V1_ANCHORS = {
  payments: 'payments',
}

const IS_V1_STAGING = window.location.href.includes('stagingcore')

export const V1_BASE_URLS = {
  dev: 'https://devcore.hapana.com/index.php',
  qa: 'https://qacore.hapana.com/index.php',
  staging: IS_V1_STAGING
    ? 'https://stagingcore.hapana.com/index.php'
    : 'https://devcore.hapana.com/index.php',
  production: IS_V1_STAGING
    ? 'https://stagingcore.hapana.com/index.php'
    : 'https://core.hapana.com/index.php',
}

export const getV1Routes = (route, params = {}, anchor = '') => {
  const paramRoute = !!route && { route }
  const joinParams = { ...paramRoute, ...params }
  const url = new URL(V1_BASE_URLS[process.env.ENVIRONMENT || 'dev'])
  const urlParams = new URLSearchParams({
    ...joinParams,
    ...(joinParams.cid && {
      cid: window.btoa(String(joinParams.cid)),
    }),
  })
  url.search = urlParams
  url.hash = anchor
  return url.href
}
